import "./SearchField.scss";
import primaryComponents from "..";
import { useEffect, useState, useCallback } from "react";
import { SearchIcon } from "../../../assets/svgIcons";

const SearchField = ({
  name = "search",
  placeholder = "Search...",
  trigger = () => {},
  value = "",
  triggerOnInput = true,
  isDebounce = false,
  showSearchBtn = false,
  classNames = "",
  useControlledValue = false,
  setValue = () => {},
  borderColor = "#7647ee",
  scanIcon,
  showClearBtn = false,
  SearchClearIcon = null,
  useBorderImage = false,
  style = {},
  ...rest
}) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    if (value !== searchValue && useControlledValue === true)
      setSearchValue(value);
  }, [value]);
  // Debounced effect for search
  useEffect(() => {
    if (!isDebounce) return;

    const handler = setTimeout(() => {
      if (searchValue?.trim()) trigger(searchValue);
    }, 500); // Reduced delay for better UX

    return () => clearTimeout(handler);
  }, [searchValue]);

  // Memoized event handlers
  const handleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      // if (useControlledValue) setValue(newValue);
      // else
      setSearchValue(newValue);

      if (triggerOnInput || (isDebounce === true && newValue === ""))
        trigger(newValue);
    },
    [setValue, triggerOnInput, trigger],
  );

  const handleSearch = useCallback(() => {
    trigger(searchValue);
  }, [searchValue, trigger]);

  const handleClear = useCallback(() => {
    setSearchValue("");
    trigger("");
  }, [trigger]);

  SearchClearIcon = SearchClearIcon || (
    <primaryComponents.Button
      classNames={"btn btn--primary smallBtn"}
      isDisabled={!searchValue || searchValue?.length === 0}
    >
      Clear
    </primaryComponents.Button>
  );

  return (
    <div
      style={{ borderColor: borderColor, ...style }}
      className={`search__field ${classNames} ${useBorderImage ? "useBorderImage" : ""}`}
    >
      {/* Search Icon (supports customization) */}
      {scanIcon || <SearchIcon style={{ color: borderColor }} />}

      {/* Search Input Field */}
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        value={searchValue}
        onChange={handleChange}
        onKeyDown={(event) => event.key === "Enter" && handleSearch()}
        aria-label={placeholder}
        data-testid="search-input"
        {...rest}
      />

      {/* Search Button (optional) */}
      {showSearchBtn && (
        <primaryComponents.Button
          className="btn btn--primary search-btn"
          onClick={handleSearch}
          style={{ background: borderColor }}
          aria-label="Search"
        >
          Search
        </primaryComponents.Button>
      )}

      {/* Clear Button (optional) */}
      {showClearBtn && !showSearchBtn && (
        <span
          className="cursor-pointer"
          onClick={handleClear}
          aria-label="Clear search"
        >
          {SearchClearIcon}
        </span>
      )}
    </div>
  );
};

export default SearchField;
